

import { useDispatch } from "react-redux"
import styled from "styled-components"
import InputDate from "../shared/input/new/InputDate"
import { useSelector } from "react-redux"
import { sendTargetDateNotification, setTargetDate } from "../../features/admin4/admin4Slice"
import getTargetDate from "../../helper/notification/getTargetDate"
import TimeInput from "../shared/input/notification/TimeInput"
import Btn from "../shared/button/Btn"
import SmallSpinner from "../shared/spinners/SmallSpinner"

const Container = styled.div`
    width: auto;
    display: flex;
    height: auto;
    gap: 20px;
    flex-direction: column;
`

const TargetDateNotificationPortalContainer = ({isAll}) => {

  const dispatch = useDispatch()

  const {
    targetDate,
    timeData,
    isLoadingSendTargetDateNotification,



    notificationSubMenuPortal,
    notificationMenuPortal,
    notificationTextPortal,
    notificationTitlePortal,

    selectedCompanyList,
  } = useSelector(state => state.admin4)

  const handleClick = () => {

    if(!isAll){

      if(timeData.minute && timeData.hour && notificationMenuPortal.value && targetDate && selectedCompanyList.length > 0 && notificationTitlePortal && notificationTextPortal){
        
        const body = {
            scheduledTime: getTargetDate({dateString:targetDate, hour: timeData.hour, minute: timeData.minute}),
            isEveryone: false,
            title: notificationTitlePortal,
            text:  notificationTextPortal,
            altRoute: notificationSubMenuPortal.value,
            route:notificationMenuPortal.value,
            scheduledNotificationRecipients: selectedCompanyList.map(item => {
              return {
                  companyId: item.id
              }
            })
        }

        dispatch(sendTargetDateNotification(body))
        
      }

    }

    else{

      if(timeData.minute && timeData.hour && notificationMenuPortal.value && targetDate && notificationTitlePortal && notificationTextPortal){
        
        const body = {
            scheduledTime: getTargetDate({dateString:targetDate, hour: timeData.hour, minute: timeData.minute}),
            isEveryone: true,
            title: notificationTitlePortal,
            text:  notificationTextPortal,
            altRoute: notificationSubMenuPortal.value,
            route:notificationMenuPortal.value,
        }
        dispatch(sendTargetDateNotification(body))
      }
    }
}


  return (
    <Container>
        <InputDate labelText={"Bildirim Gönderim Tarihi Seçiniz"} data={targetDate} setData={(e) => dispatch(setTargetDate(e.target.value))} inputWidth={"362px"}/>
        <TimeInput inputWidth={"362px"}/>
        <Btn bgColor="var(--color-main)" color="#fff" handleClick={handleClick} width={"250px"}>{isLoadingSendTargetDateNotification ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : "Bildirim Gönder"}</Btn>
        
    </Container>
  )
}

export default TargetDateNotificationPortalContainer